import { render } from "./ContactUs.vue?vue&type=template&id=1e244778"
import script from "./ContactUs.vue?vue&type=script&lang=js"
export * from "./ContactUs.vue?vue&type=script&lang=js"

import "./ContactUs.vue?vue&type=style&index=0&id=1e244778&lang=css"
script.render = render

export default script